// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3ZQwe","select":"Header_select__3ksjp","clinic":"Header_clinic__e6-Va"};